/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { FancyContainer } from '@appCanvasCommon/graphics/FancyContainer';
import { ComponentManager } from '@appCanvasCommon/component-system/ComponentManager';
import { TicketContainer } from '@appPlanApplication/tickets/TicketContainer';
import {
	HoldCircle,
	TicketDoubleTap,
	TicketDrag,
	TicketOpenEdit,
	TicketHold,
	TicketQuickStatus,
	TicketAccessibility,
	TicketHover,
} from '../interaction';
import { CanvasAngularLand } from 'src/app/app-data/interfaces/canvas-angular-land';
import { EventMode } from '@appCanvasCommon/events/event-mode.enum';
import { CursorType } from '@appCanvasCommon/events/cursor-type.enum';

export class TicketInteractionContainer extends FancyContainer {
	public components: ComponentManager;
	public override type = 'ticket';

	constructor(canvasAngularLand: CanvasAngularLand, ticketContainer: TicketContainer) {
		super();
		// window.TICKET = this;
		this.components = new ComponentManager(this);
		this.eventMode = EventMode.Static;
		this.interactiveChildren = false;
		this.cursor = CursorType.Pointer;

		// WINDOW stuff (Hack for MOC-2902)
		const tweenManager = ticketContainer.tweenManager;
		const safeRender = ticketContainer.application.markAsDirty;

		// Add interaction
		this.components.add('openTicketEdit', new TicketOpenEdit(), canvasAngularLand, ticketContainer);
		this.components.add('ticketDoubleTap', new TicketDoubleTap(), canvasAngularLand, ticketContainer);
		this.components.add('ticketDrag', new TicketDrag(), canvasAngularLand, ticketContainer);
		this.components.add('ticketHold', new TicketHold(), canvasAngularLand, ticketContainer);
		this.components.add('ticketQuickStatus', new TicketQuickStatus(), canvasAngularLand, ticketContainer);
		this.components.add('holdCircle', new HoldCircle(), canvasAngularLand, this, tweenManager, safeRender);
		this.components.add('ticketAccessibility', new TicketAccessibility(), canvasAngularLand, ticketContainer);
		// BEGIN PLACEHOLDER REPLACE AS PART OF TP-5096
		//     TP-5096 adds a Feature Flag for ticket-hover-over-info-display.
		//     When that's available, the following call should be surrounded by a test that checks that the
		//     hover feature flag is defined:
		this.components.add('ticketHover', new TicketHover(), canvasAngularLand, ticketContainer);
		// END PLACEHOLDER REPLACE AS PART OF TP-5096
	}

	/**
	 * Helper method to disable all interaction on the ticket
	 */
	public disableInteraction(): void {
		this.eventMode = EventMode.None;
		this.cursor = CursorType.None;
	}

	/**
	 * Helper method to enable all interaction on the ticket
	 */
	public enableInteraction(): void {
		this.eventMode = EventMode.Static;
		this.cursor = CursorType.Pointer;
	}
}
